import "./App.css";
import { Route, Routes } from "react-router-dom";
import AppointmentForm from "./pages/AppointmentForm";
import Home from "./pages/Home";
import { useEffect } from "react";
import { useSelector } from "react-redux";

function App() {
    const {primaryBackground, secondaryBackground} = useSelector((state) => state.dynamicStore);

    useEffect(() => {
        document.documentElement.style.setProperty('--primary-background', primaryBackground);
        document.documentElement.style.setProperty('--secondary-background', secondaryBackground);
      }, [primaryBackground, secondaryBackground]);

    return (
        <div className="App">
            <Routes>
                <Route path="/:id?" element={<Home />} />
                <Route path="/appointment" element={<AppointmentForm />} />
            </Routes>
        </div>
    );
}

export default App;
